import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "TumiPlaceholder"
}
const _hoisted_4 = {
  key: 1,
  class: "TumiExplanation"
}
const _hoisted_5 = {
  key: 5,
  class: "row mt-5 g-0 mb-5"
}
const _hoisted_6 = { class: "col-3 ps-5" }
const _hoisted_7 = { class: "col-9" }
const _hoisted_8 = {
  key: 6,
  class: "row mt-5 g-0 mb-5"
}
const _hoisted_9 = { class: "col-3 ps-5" }
const _hoisted_10 = { class: "col-9" }
const _hoisted_11 = {
  key: 2,
  class: "TumiError mb-3"
}
const _hoisted_12 = {
  key: 3,
  class: "TumiPass mb-3"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DynamicComponent = _resolveComponent("DynamicComponent")!
  const _component_DynamicTextArea = _resolveComponent("DynamicTextArea")!
  const _component_DynamicFile = _resolveComponent("DynamicFile")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_DynamicSelect = _resolveComponent("DynamicSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.name)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.name), 1))
      : _createCommentVNode("", true),
    (_ctx.desc)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.desc), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.inputs as IControl[]), (inp) => {
      return (_openBlock(), _createElementBlock("div", {
        key: inp.name
      }, [
        (_ctx.repeatPlaceholder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(inp.placeholder), 1))
          : _createCommentVNode("", true),
        (inp.explanation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(inp.explanation), 1))
          : _createCommentVNode("", true),
        (!inp.type)
          ? (_openBlock(), _createBlock(_component_DynamicComponent, {
              key: 2,
              inputModel: inp,
              ref_for: true,
              ref: inp.name
            }, null, 8, ["inputModel"]))
          : _createCommentVNode("", true),
        (inp.type && inp.type == 'TextArea')
          ? (_openBlock(), _createBlock(_component_DynamicTextArea, {
              key: 3,
              inputModel: inp,
              ref_for: true,
              ref: inp.name
            }, null, 8, ["inputModel"]))
          : _createCommentVNode("", true),
        (inp.type && inp.type == 'Files')
          ? (_openBlock(), _createBlock(_component_DynamicFile, {
              key: 4,
              inputModel: inp,
              ref_for: true,
              ref: inp.name,
              number: inp.fileCount,
              types: inp.fileTypes
            }, null, 8, ["inputModel", "number", "types"]))
          : _createCommentVNode("", true),
        (inp.type == 'Date')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(inp.placeholder), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Datepicker, {
                  modelValue: inp.value,
                  "onUpdate:modelValue": ($event: any) => ((inp.value) = $event),
                  autoApply: "",
                  format: 'dd/MM/yyyy',
                  enableTimePicker: false
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (inp.type == 'DropDown')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(inp.placeholder), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_DynamicSelect, {
                  inputModel: inp,
                  ref_for: true,
                  ref: inp.name
                }, null, 8, ["inputModel"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_ctx.validate)
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.validate), 1))
      : _createCommentVNode("", true),
    (_ctx.pass)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.pass), 1))
      : _createCommentVNode("", true),
    (!_ctx.buttonClass)
      ? (_openBlock(), _createElementBlock("button", {
          key: 4,
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Submit && _ctx.Submit(...args)))
        }, "Save"))
      : _createCommentVNode("", true),
    (_ctx.buttonClass)
      ? (_openBlock(), _createElementBlock("button", {
          key: 5,
          class: _normalizeClass(_ctx.buttonClass),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.Submit && _ctx.Submit(...args)))
        }, "Save", 2))
      : _createCommentVNode("", true),
    _hoisted_13
  ], 64))
}